module.exports = __webpack_public_path__ + "img/43_17.02f7b765.png";